import { AsyncPipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import type { ActionButton } from '@bizzdesign/shared/models';
import { ActionStatePipe, GetNoAccessKeyPipe } from '@bizzdesign/shared/utils';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'bd-object-search-results-header',
  imports: [
    AsyncPipe,
    NgClass,
    FormsModule,
    SharedI18nModule,
    CheckboxModule,
    ButtonModule,
    DividerModule,
    TooltipModule,
    ActionStatePipe,
    GetNoAccessKeyPipe,
  ],
  templateUrl: './object-search-results-header.component.html',
  styleUrl: './object-search-results-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectSearchResultsHeaderComponent {
  @Input() isSelectionMode: boolean = false;
  @Input() numberOfSelectedItems: number = 0;
  @Input() actions: ActionButton[] = [];
  @Input() totalSearchResultsCount: number = 0;
  @Input() selectAllDisabled: boolean = false;
  @Input() showSelectAllButton: boolean = true;

  @Output() selectionCanceled: EventEmitter<void> = new EventEmitter();
  @Output() selectAllClicked: EventEmitter<void> = new EventEmitter();

  onSelectAllClick(): void {
    this.selectAllClicked.emit();
  }

  onCancel(): void {
    this.selectionCanceled.emit();
  }
}
